<template>
    <card>
      <template class="card-header" slot="header">
        <h4 class="card-title">
          RAM Information
          <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
            <font-awesome-icon icon="sync"></font-awesome-icon>
          </button>
        </h4>
        <p class="card-category">General information about the RAM Memory size.</p>
      </template>
      <table class="table table-borderless beast-info-table">
        <tr>
          <th class="beast-key">Total:</th>
          <td class="beast-value">{{ramInfo.totalMemory}}</td>
        </tr>
        <tr>
          <th class="beast-key">Used:</th>
          <td class="beast-value">{{ramInfo.usedMemory}}</td>
        </tr>
        <tr>
          <th class="beast-key">Free:</th>
          <td class="beast-value">{{ramInfo.freeMemory}}</td>
        </tr>
      </table>
    </card>
</template>

<script>
export default {
  props: {
    ramInfo: {
      type: Object,
      required: true
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  name: "RAMInfo"
};
</script>

<style scoped>

</style>
